import { createContext, useContext } from 'react';

export const THEME_STORAGE_KEY = 'erp-theme';

export const THEMES = ['light', 'dark', 'system'] as const;
export type Theme = (typeof THEMES)[number];

export interface ThemeContextValue {
  theme: Theme;
  resolvedTheme: Exclude<Theme, 'system'>;
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider.');
  }
  return context;
}

export function isTheme(value: string | null): value is Theme {
  return value !== null && THEMES.some((theme) => theme === value);
}
